import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';
import { ClienteComponent } from './cliente/cliente.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule  } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule as MatListModule } from '@angular/material/list';
import { MainNavComponent } from './main-nav/main-nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { DialogRecuperarPasswordComponent } from './dialog-recuperar-password/dialog-recuperar-password.component';
import { UserAccountComponent } from './user-account/user-account.component';
import { MiActividadComponent } from './mi-actividad/mi-actividad.component';
import { SoportepageComponent } from './soportepage/soportepage.component';
import { MatDividerModule } from '@angular/material/divider';
import { DefaultModule } from './layouts/default/default.module';
import { LandingComponent } from './landing/landing.component';
import { SignupComponent } from './signup/signup.component';
import { JwtInterceptor } from './security/jwt.interceptor';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TableusrComponent } from './modules/user/userindex/tableusr/tableusr.component';
import { UserindexComponent } from './modules/user/userindex/userindex.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
//import { FileUploadModule } from 'ng2-file-upload';
import { ProfilesComponent } from './modules/profiles/profiles.component';
import { CreateedituserComponent } from './modules/user/userindex/createedituser/createedituser.component';
import { RestorepasswordComponent } from './modules/manageAccount/restorepassword/restorepassword.component';
import { IndexDisciplinaComponent } from './modules/disciplina/index-disciplina/index-disciplina.component';
import { IndexEmpleadosComponent } from './modules/user/index-empleados/index-empleados.component';
import { IndexDeportistasComponent } from './modules/user/index-deportistas/index-deportistas.component';
import { CreateEditDisciplinaComponent } from './modules/disciplina/create-edit-disciplina/create-edit-disciplina.component';
import { IndexHorarioComponent } from './modules/horario/index-horario/index-horario.component';
import { CreateEditHorarioComponent } from './modules/horario/create-edit-horario/create-edit-horario.component';
import { IndexEmpresaComponent } from './modules/empresa/index-empresa/index-empresa.component';
import { IndexHorarioAdminComponent } from './modules/horario/index-horario-admin/index-horario-admin.component';
import { IndexOrdenCompraComponent } from './modules/ordenCompra/index-orden-compra/index-orden-compra.component';
import { CreateEditOrdenCompraComponent } from './modules/ordenCompra/create-edit-orden-compra/create-edit-orden-compra.component';
import { IndexOrdenCompraAdminComponent } from './modules/ordenCompra/index-orden-compra-admin/index-orden-compra-admin.component';
import { IndexDetalleOrdenCompraComponent } from './modules/ordenCompra/index-detalle-orden-compra/index-detalle-orden-compra.component';
import { IndexDetalleOrdenCompraAdminComponent } from './modules/ordenCompra/index-detalle-orden-compra-admin/index-detalle-orden-compra-admin.component';
import { CreateEditEmpresaComponent } from './modules/empresa/create-edit-empresa/create-edit-empresa.component';
import { CreateEditEmpleadoComponent } from './modules/user/create-edit-empleado/create-edit-empleado.component';
import { CreateEditDeportistaComponent } from './modules/user/create-edit-deportista/create-edit-deportista.component';
import { EditDisciplinaUserComponent } from './modules/user/index-deportistas/edit-disciplina-user/edit-disciplina-user.component';
import { EditHorariosDeportistaComponent } from './modules/user/index-deportistas/edit-horarios-deportista/edit-horarios-deportista.component';
import { IngesosHoyComponent } from './modules/reportes/ingesos-hoy/ingesos-hoy.component';
import { IngresosFechasComponent } from './modules/reportes/ingresos-fechas/ingresos-fechas.component';
import { ModalQrComponent } from './modules/varios/modal-qr/modal-qr.component';

import { EditDetalleUsuariosComponent } from './modules/user/edit-detalle-usuarios/edit-detalle-usuarios.component';
import { PerfilEmpresaComponent } from './modules/empresa/perfil-empresa/perfil-empresa.component';
//import { PuntosGraficaComponent } from './shared/widget/puntos-grafica/puntos-grafica.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MomentDateModule} from '@angular/material-moment-adapter' ;
import { MatNativeDateModule } from '@angular/material/core';
import { IndexOrdenCompraAdminHistoricoComponent } from './modules/ordenCompra/index-orden-compra-admin-historico/index-orden-compra-admin-historico.component';
import { EditFechaFinServicioEmpresaComponent } from './modules/empresa/edit-fecha-fin-servicio-empresa/edit-fecha-fin-servicio-empresa.component';
import { AgregarAdministradorEmpresaComponent } from './modules/empresa/agregar-administrador-empresa/agregar-administrador-empresa.component';
import { ConfiguracionGlobalComponent } from './modules/configuracion-global/configuracion-global.component';
import { IndexSeleccionLigaComponent } from './modules/user/index-seleccion-liga/index-seleccion-liga.component';
import { EditarSaldoComponent } from './modules/empresa/editar-saldo/editar-saldo.component';
import { CambioPlanComponent } from './modules/user/index-deportistas/cambio-plan/cambio-plan.component';
import { ActualizaFotoUsuarioComponent } from './modules/user/index-deportistas/actualiza-foto-usuario/actualiza-foto-usuario.component';
import { IngresosExtraordinariosComponent } from './modules/reportes/ingresos-extraordinarios/ingresos-extraordinarios.component';
import { IngresosExtraordinariosAdminComponent } from './modules/reportes/ingresos-extraordinarios-admin/ingresos-extraordinarios-admin.component';
import { IngresosUnicosPorFechasComponent } from './modules/reportes/ingresos-unicos-por-fechas/ingresos-unicos-por-fechas.component';
import { IndexMovimientosComponent } from './modules/movimiento/index-movimientos/index-movimientos.component';
import { IndexMovimientosAdminComponent } from './modules/movimiento/index-movimientos-admin/index-movimientos-admin.component';
import { HistorialIngresosUsuarioComponent } from './modules/user/historial-ingresos-usuario/historial-ingresos-usuario.component';
import { IndexConsutlaPlanesComponent } from './modules/plan/index-consutla-planes/index-consutla-planes.component';
import { IndexPlanesAdminComponent } from './modules/plan/index-planes-admin/index-planes-admin.component';
import { CreateEditPlanComponent } from './modules/plan/index-planes-admin/create-edit-plan/create-edit-plan.component';
import { ListadoAdministradoresComponent } from './modules/empresa/index-empresa/listado-administradores/listado-administradores.component';
import { ListadoQrsComponent } from './modules/user/index-deportistas/listado-qrs/listado-qrs.component';
import { TomarFotoWebcamComponent } from './modules/user/tomar-foto-webcam/tomar-foto-webcam.component';
import { WebcamModule } from 'ngx-webcam';
import { CodigoQrPublicoComponent } from './modules/user/codigo-qr-publico/codigo-qr-publico.component';
import { ComentarioOrdenCompraComponent } from './modules/ordenCompra/comentario-orden-compra/comentario-orden-compra.component';
import { AddExtencionComponent } from './modules/user/index-deportistas/add-extencion/add-extencion.component';
import { IndexExtencionComponent } from './modules/extencion/index-extencion/index-extencion.component';
import { DeportistasPorExpirarComponent } from './modules/reportes/deportistas-por-expirar/deportistas-por-expirar.component';
import { DetalleOrdenCompraReporteComponent } from './modules/ordenCompra/detalle-orden-compra-reporte/detalle-orden-compra-reporte.component';
import { UsuariosXHorarioComponent } from './modules/horario/usuarios-xhorario/usuarios-xhorario.component';
import { DetalleOrdenCompraReporteAdminComponent } from './modules/ordenCompra/detalle-orden-compra-reporte-admin/detalle-orden-compra-reporte-admin.component';
import { ModalListadoExtencionesComponent } from './modules/user/index-deportistas/modal-listado-extenciones/modal-listado-extenciones.component';
import { ModalListadoOrdenesCompraUsuarioComponent } from './modules/user/index-deportistas/modal-listado-ordenes-compra-usuario/modal-listado-ordenes-compra-usuario.component';
import { IndexDeportistasAltoRendimientoComponent } from './modules/user/index-deportistas-alto-rendimiento/index-deportistas-alto-rendimiento.component';
import { HojaUsuarioAdminComponent } from './modules/user/hoja-usuario-admin/hoja-usuario-admin.component';
import { HojaUsuarioComponent } from './modules/user/hoja-usuario/hoja-usuario.component';
import {ConfirmarCreacionOrdenCompraComponent} from './modules/ordenCompra/confirmar-creacion-orden-compra/confirmar-creacion-orden-compra.component'
import { IngresosFechasAdminComponent } from './modules/reportes/ingresos-fechas-admin/ingresos-fechas-admin.component';
import { CustomDatePipe } from './shared/pipes/custom.datepipe';
//import { TableResponsiveDirective } from './directives/table-responsive.directive';
import { QRCodeModule } from 'angularx-qrcode';
//import {MatFormFieldModule} from '@angular/material/form-field';
//import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import more from 'highcharts/highcharts-more.src';
import exporting from 'highcharts/modules/exporting.src';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import { ModDirectivasModule } from './directives/mod-directivas/mod-directivas.module';
import { SeleccionFechaReporteExcelComponent } from './modules/reportes/ingresos-fechas-admin/seleccion-fecha-reporte-excel/seleccion-fecha-reporte-excel.component';
import {IngresosCuadroComponent }from './modules/reportes/ingresos-cuadro/ingresos-cuadro.component'
import { IndexDeportistasEliminadosComponent } from './modules/user/index-deportistas-eliminados/index-deportistas-eliminados.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ClienteComponent,
    LoginComponent,
    MainNavComponent,
    DialogRecuperarPasswordComponent,
    UserAccountComponent,
    MiActividadComponent,
    SoportepageComponent,
    LandingComponent,
    SignupComponent,
    TableusrComponent,
    UserindexComponent,
    ProfilesComponent,
    CreateedituserComponent,
    RestorepasswordComponent,
    IndexDisciplinaComponent,
    IndexEmpleadosComponent,
    IndexDeportistasComponent,
    CreateEditDisciplinaComponent,
    IndexHorarioComponent,
    CreateEditHorarioComponent,
    IndexEmpresaComponent,
    IndexHorarioAdminComponent,
    IndexOrdenCompraComponent,
    CreateEditOrdenCompraComponent,
    IndexOrdenCompraAdminComponent,
    IndexDetalleOrdenCompraComponent,
    IndexDetalleOrdenCompraAdminComponent,
    CreateEditEmpresaComponent,
    CreateEditEmpleadoComponent,
    CreateEditDeportistaComponent,
    EditDisciplinaUserComponent,
    EditHorariosDeportistaComponent,
    IngesosHoyComponent,
    IngresosFechasComponent,
    ModalQrComponent,
    EditDetalleUsuariosComponent,
    PerfilEmpresaComponent,
    IndexOrdenCompraAdminHistoricoComponent,
    EditFechaFinServicioEmpresaComponent,
    AgregarAdministradorEmpresaComponent,
    ConfiguracionGlobalComponent,
    IndexSeleccionLigaComponent,
    EditarSaldoComponent,
    CambioPlanComponent,
    ActualizaFotoUsuarioComponent,
    IngresosExtraordinariosComponent,
    IngresosExtraordinariosAdminComponent,
    IngresosUnicosPorFechasComponent,
    IndexMovimientosComponent,
    IndexMovimientosAdminComponent,
    HistorialIngresosUsuarioComponent,
    IndexConsutlaPlanesComponent,
    IndexPlanesAdminComponent,
    CreateEditPlanComponent,
    ListadoAdministradoresComponent,
    ListadoQrsComponent,
    TomarFotoWebcamComponent,
    CodigoQrPublicoComponent,
    ComentarioOrdenCompraComponent,
    AddExtencionComponent,
    IndexExtencionComponent,
    DeportistasPorExpirarComponent,
    DetalleOrdenCompraReporteComponent,
    UsuariosXHorarioComponent,
    DetalleOrdenCompraReporteAdminComponent,
    ModalListadoExtencionesComponent,
    ModalListadoOrdenesCompraUsuarioComponent,
    IndexDeportistasAltoRendimientoComponent,
    HojaUsuarioAdminComponent,
    HojaUsuarioComponent,
    IngresosFechasAdminComponent,
    SeleccionFechaReporteExcelComponent,
   // ConfirmarCreacionOrdenCompraComponent,
    CustomDatePipe,
   // PuntosGraficaComponent
   IngresosCuadroComponent,
   IndexDeportistasEliminadosComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    FormsModule,
    MatInputModule,
    MatCardModule,
    HttpClientModule,
    MatListModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    MatMenuModule,
    MatDialogModule,
    MatTableModule,
    MatSelectModule,
    MatDividerModule,
    DefaultModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
   // FileUploadModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
   // NgIdleKeepaliveModule.forRoot(),
   QRCodeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MomentDateModule,
    WebcamModule,
    HighchartsChartModule,
    ModDirectivasModule,
 //   ChartModule 
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    //{ provide: HIGHCHARTS_MODULES, useFactory: () => [more, exporting] },
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
